import React from "react";
import HomeIcon from "@material-ui/icons/Home";
import ReceiptIcon from "@material-ui/icons/Receipt";
import QrCodeScannerIcon from "@material-ui/icons/CropFree";
import EventIcon from "@material-ui/icons/Event";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import CitizenShell from "./CitizenShell";

var TABS = [
  { path: "/citizen", label: "Home", icon: HomeIcon, exact: true },
  { path: "/citizen/bookings", label: "Bookings", icon: ReceiptIcon },
  { path: "/citizen/scan", label: "Scan", icon: QrCodeScannerIcon },
  { path: "/citizen/events", label: "Events", icon: EventIcon },
  { path: "/citizen/more", label: "You", icon: PersonOutlineIcon },
];

export default function CitizenLayout({ title, children, hideNav, backTo, backLabel, fab }) {
  return (
    <CitizenShell
      variant="guest"
      title={title}
      hideNav={hideNav}
      backTo={backTo}
      backLabel={backLabel}
      tabs={TABS}
      fab={fab}
    >
      {children}
    </CitizenShell>
  );
}
